import { Page } from '@app/components/page/Page';
import { BreadcrumbItem } from '@mi-front/ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { stationGroupsMessages } from './station-groups-messages';

/**
 * Breadcrumbs for station-groups admin screens (list root → optional active name).
 */
export function StationGroupsBreadcrumbs(p: {
  activeText?: React.ReactNode;
  title?: React.ReactNode;
}) {
  const groupsText = (
    <span className="text-capitalize-first">
      <FormattedMessage {...stationGroupsMessages.breadcrumb} />
    </span>
  );

  const activeText = p.title || p.activeText;

  const items: BreadcrumbItem[] = activeText
    ? [
        {
          content: groupsText,
          href: '/admin/station-groups',
        },
        {
          content: activeText,
          active: true,
        },
      ]
    : [
        {
          content: groupsText,
          active: true,
        },
      ];

  return <Page.Breadcrumbs items={items} />;
}
